import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=a83b924a&scoped=true&"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayout.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./DefaultLayout.vue?vue&type=style&index=1&id=a83b924a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83b924a",
  null
  
)

export default component.exports